/*************
このファイルは convert-locales コマンドにより自動生成されたものです
修正するには大元のymlファイルを編集し、convert-locales コマンドを実行してください
*************/
export const ja = {
  locale: 'ja',
  messages: {
    'dialog.cancel': 'キャンセル',
    'dialog.ok': 'OK',
    'deviceFamilyNames.0': 'iPhone',
    'deviceFamilyNames.1': 'iPad',
    'deviceFamilyNames.2': 'iPhone/iPad',
    'pullToRefresh.pullToRefresh': '再読み込み',
    'pullToRefresh.releaseToRefresh': '再読み込み',
    'pullToRefresh.refreshing': '読み込み中',
    'alert.error': 'エラーが発生しました。時間を置いてもう一度お試しください。',
    'alert.startBinaryInstall':
      'インストールを開始しました。ホーム画面にてご確認ください。',
    'prompt.inputDisplayName': '名前を入力してください',
    'confirm.leaveTest': 'アプリのテストを中止しますか？',
    'loginForm.submit': 'ログイン',
    'loginForm.email': 'メールアドレス',
    'loginForm.password': 'パスワード',
    'appFileInfo.releaseDate': 'リリース日',
    'appFileInfo.TTL': '有効期限',
    'appFileInfo.size': 'サイズ',
    'appFileInfo.compatibility': '互換性',
    'appFileInfo.targetDeviceFamily': '対象デバイス',
    'samlLoginForm.help':
      'SAML 認証はエンタープライズプランでのみサポートされています。',
    'samlLoginForm.enterpriseName': 'エンタープライズ名',
    'samlLoginForm.enterpriseNameFormat':
      'エンタープライズ名は英数字、-、_のみで構成されています。',
    'samlLoginForm.submit': 'ログイン',
    'signUpForm.submit': '新規登録',
    'signUpForm.email': 'メールアドレス',
    'signUpForm.password': 'パスワード',
    'signUpForm.username': '希望ユーザ名(半角3〜20文字)',
    'signUpForm.termsAccept':
      '<terms>利用規約</terms>および<privacyPolicy>プライバシーポリシー</privacyPolicy>に同意します',
    'signUpForm.emailValidatedMessage': 'メールアドレスの確認が完了しました。',
    'signUpEmailForm.email': 'メールアドレス',
    'signUpEmailForm.help':
      '入力されたメールアドレス宛に確認コードをお送りします。',
    'signUpEmailForm.submit': '確認コードを送信する',
    'signUpValidateForm.code': '確認コード',
    'signUpValidateForm.sentMessage':
      'メールアドレス宛に確認コードを送信しました。ご確認ください。',
    'signUpValidateForm.resend': '確認コードを再送信する',
    'signUpValidateForm.submit': '確認する',
    'appInstall.version': 'バージョン',
    'appInstall.updatedAt': '最終更新日',
    'appInstall.overwriteInstall': 'App Store版を上書き',
    'appInstall.unsupportedOverwriteInstall':
      '現在お使いの iOS {deviceOsVersion} では、App Store版の上書きには対応しておりません。',
    'appInstall.install': 'インストール',
    'appInstall.binaryOverSize':
      '注意: このアプリのダウンロードにはWi-Fiネットワークが必要です。ダウンロードはWi-Fiに接続するまで保留されます。',
    'appInstall.expiredProvisioningProfile.developer':
      'アプリの有効期限が切れています。プロビジョニングプロファイルを更新して、再度アップロードしてください。',
    'appInstall.expiredProvisioningProfile.tester':
      'アプリの有効期限が切れています。開発者にお問い合わせください。',
    'appInstall.unsupportedDevice':
      'このバージョンの対象デバイスは {targetDevice} お使いの登録デバイスは {currentDevice} です。',
    'appInstall.unsupportedOsVersion':
      'このバージョンの対象OSは {minimumOsVersion} お使いの登録デバイスは {deviceOsVersion} です。',
    'appInstall.notRegisteredIphone.developer':
      'この端末のUDIDがプロビジョニングプロファイルに登録されていません。プロビジョニングプロファイルを更新して、再度アップロードしてください。',
    'appInstall.notRegisteredIphone.tester':
      '配布準備中です。開発者にお問い合わせください。',
    'appInstall.duplicateIconNotice':
      '既存アプリを更新するとインストール中はアイコンが増えますが完了すると1つに戻ります。',
    'appInstall.enterpriseAcceptProfile':
      'アプリが起動できないときは:「信頼されていないエンタープライズ開発元」と表示される場合、設定アプリを開き、一般→プロファイル から、エンタープライズAPP {teamName} を開いて「"{teamName}"を信頼」ボタンを押してください。',
    'appInstall.adhocEnableDeveloperMode':
      'このアプリを起動するには端末のデベロッパーモードを有効にする必要があります。ホーム画面から「設定」→「プライバシーとセキュリティ」の下にある「デベロッパーモード」を開き、スイッチをオンにして表示される指示に従ってください。',
    'appDetail.releaseNote': 'リリースノート',
    'appDetail.info': 'アプリケーション情報',
    'appDetail.distributionUpdatedDate': '最終更新',
    'commentDetail.reply': '{name}への返信',
    'commentDetail.unknownUserName': '不明なユーザー',
    'commentModal.placeholder.defult': 'コメント',
    'commentModal.placeholder.withReplyName': '{name}への返信',
    'commentModal.cancel': 'キャンセル',
    'commentModal.submit': '投稿する',
    'configurationProfileInfo.suggestUpdate':
      'デスクトップ用Webサイトで表示しているため、iOSのバージョンが取得できませんでした。お使いのデバイスのiOSバージョンが {deviceOsVersion} と異なる場合は、<reInstallProfile>プロファイルの再インストール</reInstallProfile>をお願いいたします。',
    'configurationProfileInfo.confirm.reInstall':
      'プロファイルを再インストールしますか？',
    'loginPageLayout.OAuthLogin.linkTitle':
      'GitHubまたはGoogleアカウントでログインする',
    'loginPageLayout.OAuthLogin.github': 'GitHubアカウントでログインする',
    'loginPageLayout.OAuthLogin.google': 'Googleアカウントでログインする',
    'loginPageLayout.SAML': 'SAML認証でログインする',
    'loginPageLayout.signup': 'アカウントをお持ちでない方',
    'loginPageLayout.reminder': 'パスワードをお忘れの方',
    'configurationProfilePageLayout.title': 'インストール',
    'configurationProfilePageLayout.deploygate': 'DeployGate',
    'configurationProfilePageLayout.help':
      '招待されたアプリを使用するために「DeployGate」をインストールしましょう。',
    'configurationProfilePageLayout.udidHelp':
      '端末識別情報(UDID)をアプリ開発者に提供します。',
    'configurationProfilePageLayout.install': 'DeployGateをインストール',
    'configurationProfilePageLayout.guide1':
      'iPhoneの「設定」でプロファイルのインストールが完了すると、iPhoneのホーム画面に「DeployGate」が追加されています。',
    'configurationProfilePageLayout.guide2':
      '招待されたアプリは「DeployGate」の中からインストール可能です。',
    'configurationProfilePageLayout.logout': 'ログアウト',
    'configurationProfilePageLayout.installNotice':
      '上記ボタンからプロファイルをダウンロードした後、iPhone の「設定」からインストールする必要があります。',
    'signUpPageLayout.banner':
      'DeployGateはアカウント情報をGDPR、日本の個人情報保護法およびプライバシーポリシーに従って適切に管理します。',
    'signUpPageLayout.login': '既にアカウントをお持ちの方',
    'appsPageLayout.title': 'アプリ一覧',
    'appsPageLayout.availableApps': '利用可能アプリ',
    'appsPageLayout.logout': 'ユーザーを切り替える',
    'appsPageLayout.login': 'ログイン',
    'appsPageLayout.reInstall': 'DeployGateを再インストール',
    'appsPageLayout.noAvailableApps': '開発者からの連絡をお待ちください',
    'appsPageLayout.waitForEnginner':
      '現在この端末用のアプリを準備中です。準備ができ次第、登録されたメールアドレスへお知らせします。',
    'appsPageLayout.notificationSetting': 'メール通知設定',
    'appsPage.confirm.logout': 'ログアウトしてもよろしいですか？',
    'appsPage.confirm.reInstall': 'DeployGateを再インストールしますか？',
    'appsPage.terms.title': '利用規約・各種ポリシー',
    'appDetailPageLayout.title': 'アプリのインストール',
    'appDetailPageLayout.otherVersions': 'これまでのバージョン',
    'appDetailPageLayout.showOtherVersions': 'さらに表示',
    'appSearchPageLayout.title': 'アプリの検索',
    'appSearchPageLayout.inputPlaceholder':
      'アプリのバージョンとその説明を検索',
    'distributionDetailPageLayout.waitingForTester.explanationHeader':
      '次のバージョンからインストールできます',
    'distributionDetailPageLayout.waitingForTester.explanationBody':
      '開発者がこの{deviceType}で利用できる新しいバージョンを用意しますのでお待ちください。',
    'distributionDetailPageLayout.waitingForTester.laterGuideHeader':
      '次のバージョンが準備できたら?',
    'distributionDetailPageLayout.waitingForTester.laterGuideBody':
      'ホーム画面にあるDeployGateからアプリをインストールできるようになります。後ほどご確認ください。',
    'distributionDetailPageLayout.displayName':
      '{displayName}としてテストに参加中',
    'distributionDetailPageLayout.comment': 'コメントを見る・投稿する',
    'distributionDetailPageLayout.changeDisplayName': '名前を変更する',
    'distributionDetailPageLayout.leave': 'テストをやめる',
    'distributionDetailPageLayout.notification': '通知設定',
    'distributionDetailPageLayout.changeNotificationOn': '通知をオンにする',
    'distributionDetailPageLayout.changeNotificationOff': '通知をオフにする',
    'commentsPageLayout.title': 'コメント',
    'commentsPage.confirm.delete': '削除してもよろしいですか?',
    'notificationSettingPageLayout.title': '通知設定',
    'notificationSettingPageLayout.submit': '設定する',
    'notificationSettingPageLayout.remove': '通知設定を削除する',
    'notificationSettingPageLayout.placeholder': 'メールアドレス',
    'notificationSettingPage.sendEmailActivation':
      '{email}宛にDeployGateよりメールを送りました。ご確認ください。',
    'notificationSettingPage.confirm.delete': '削除してもよろしいですか?',
    'invitation.headerTitle': '招待',
    'invitation.invitee': '{email} さん',
    'invitation.message': '{inviter} さんから<br />{name} に招待されています。',
    'invitation.signUpHelp': '1分で登録できます!',
    'invitation.signUpForApp': '新規登録してインストール',
    'invitation.signUpForGroup': '新規登録',
    'invitation.loginHelp': '既にアカウントをお持ちの場合',
    'invitation.login': 'ログイン',
    'unavailableInvitation.title': '無効な招待です。',
    'unavailableInvitation.message':
      'この招待URLはすでに期限が切れているか、不正な形式のため利用できません。<br />招待者に連絡してご確認ください。',
    'unavailableInvitation.back': 'Topにもどる',
    'emailActivationPage.title': 'メールアドレスの確認',
    'emailActivationPage.success': 'メールアドレスの認証が完了しました!',
    'emailActivationPage.error.tokenInvalid':
      'このURLは無効です。DeployGateからのメールを再確認してください。',
    'showExceptionError.title': 'エラーが発生しました。',
    'showExceptionError.subTitle': '時間を置いて再度お試しください。',
    'showExceptionError.back': 'もどる',
    'emailValidation.invalid.format':
      'ASCIIコード以外の文字がドメイン部分に含まれています。再度ご確認ください。',
    'error.notSafari.requiredSafari': 'このページはSafariで開く必要があります',
    'error.notSafari.openSafari': 'Safariを起動する',
    'error.notSafari.copyHtml':
      'URLをコピーし、{br}Safariのアドレスバーにペーストして開いてください。',
    'error.notSafari.copyUrl': 'URLをコピーする',
    'error.hint.cookieOff':
      'SafariのCookieが無効の場合はご利用できません。設定アプリから有効にしてください。',
    'error.hint.privateBrowser':
      'プライベートブラウズの場合はご利用できません。',
    'api.error.distributionNotFound': 'その配布ページは存在しません',
    'api.error.general':
      'エラーが発生しました。時間を置いてもう一度お試しください。',
    'api.error.invalidEmailOrPassword': 'ユーザ名またはパスワードが違います。',
    'api.error.notConnectedToInternet': 'インターネットに接続されていません。',
    'api.error.someRequiredParamsIsBlank':
      '入力必須の項目に未入力項目があります。',
    'api.error.notAcceptedTerms':
      '利用規約およびプライバシーポリシーに同意する必要があります。',
    'api.error.thisNameIsAlreadyUsed': 'このユーザ名は既に使用されています。',
    'api.error.thisEmailIsAlreadyUsed':
      'このメールアドレスは既に使用されています。',
    'api.error.tokenIsInvalid': 'Tokenが不正です',
    'api.error.noSessionFound': 'セッションが存在しません',
    'api.error.noEnterpriseFound': 'エンタープライズが見つかりませんでした。',
    'api.error.SamlAuthenticationDisabled': 'SAML 認証が有効ではありません',
    'api.error.distributionDisplayNameInvalidCharacters':
      '名前には3文字以上のa-z, 0-9, _, -のみが使用可能です',
    'api.error.invalidEmail': 'メールアドレスの形式が違います',
    'api.error.thisDistributionLimitedAccesses':
      'この配布ページはアクセスできる人を制限しています',
    'api.error.thisIphoneWasLooggedIn':
      'このiPhone/iPadは既に他のアカウントでログイン済みです。再度ログインをお試しください',
    'api.error.notFoundIphone': 'iPhone/iPadが見つかりませんでした',
    'api.error.thisEmailIsAlreadyInUse':
      'このメールアドレスはご利用いただけません。別のメールアドレスをお試しください。',
    'api.error.theseTransactionKeyAndCodeWereInvalid':
      '確認コードの検証に失敗しました。確認コードをご確認ください。',
    'api.error.TheTransactionKeyHasBeenInvalidated':
      '確認コードが無効になりました。 確認コードを再送信してください。',
    'api.error.TooManyRequests':
      '類似のリクエストが多いため受け付けられませんでした。時間をあけてお試しください。',
    'api.error.SsoAuthDueDateOver':
      'このiOSデバイスはログアウトしました。現在ご利用のDeployGateアカウントは移行する必要があるので、利用することができません。',
    'api.error.NotFoundOrNeedToLogIn':
      'この配布ページは存在しないか、もしくは、アクセス権のあるアカウントでログインする必要があります。',
    'api.error.name.too_short':
      'ユーザー名は3文字以上、20文字以内にしてください。',
    'api.error.name.too_long':
      'ユーザー名は3文字以上、20文字以内にしてください。',
    'api.error.name.invalid': 'a-z, 0-9, _, -のみが使用可能です。',
    'api.error.name.taken': 'この名前は既に使われています。',
    'api.error.password.length': 'パスワードは6文字以上にしてください。',
  },
};
